<template>
    <div class="">
        <div class="seachBox">
            <div class="seachList">
                <span class="name">分组名称：</span>
                <a-select v-model="search.group_id" placeholder="请选择" class="seachs" allowClear  @change="getBtnList">
                    <a-select-option :value="item.id" :key="index" v-for="(item,index) in seachList.groupList">
                        {{item.name}}
                    </a-select-option>
                </a-select>
            </div>
            <div class="seachList">
                <span class="name">按钮名称：</span>
                <a-select v-model="search.btn_id" option-filter-prop="children" :filter-option="filterOption" placeholder="请选择" class="seachs" :showSearch="true" allowClear>
                    <a-select-option :value="item.id" :key="index" v-for="(item,index) in seachList.btnList">
                        {{item.name}}
                    </a-select-option>
                </a-select>
            </div>
            <div class="seachList">
                <span class="name">日期：</span>
                <a-range-picker class="seachs seachs-time"
                v-model="statistics_date" :disabledDate="disabledDate" allowClear :showTime="false" format="YYYY-MM-DD" @change="(date,dateString) => onChangeTime(date,dateString,'statistics_date')"/>
            </div>
          <div class="seachList" style="padding-left: 20px">
            <a-button type="primary" class="top_btn" @click="getList()">搜索</a-button>
            <a-button   class="top_btn" @click="empty">清空条件</a-button>
          </div>
        </div>
        <div class="flex" >
            <div><a-button class="top_btn" type="primary"   @click="exportList()"  >
                批量导出
            </a-button>
                <span style="margin-left: 8px">
        <template v-if="hasSelected">
          {{ `选中 ${selectedRowKeys.length} 项` }}
        </template></span></div>

        </div>
        <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="pagination" rowKey="id" @change="handleChange" :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" >
            <span slot="total_users" slot-scope="text, record">
                 <span v-if="text==0">{{text}}</span>
                 <router-link  tag="a" v-else
                     :to="{ path:'/DataStatistics/BehaviorDetails', query:{id:record.id,statistics_date:statisticsDate}}">
                   {{text}}
                 </router-link>

            </span>
        </a-table>

    </div>

</template>

<script>
    import API from "./api";
    import moment from 'moment';
    import {changStatus, removeById,orderList} from "../../../utils/utils"
    // sorter: true,

    const fdate=()=>{
      let nowdate = new Date();
      let y = nowdate.getFullYear();
      let m = nowdate.getMonth()+1;
      let d = nowdate.getDate();
      return   y+'-'+m+'-'+d;
    }
    const nowdate=()=>{
      let nowdate = new Date();
      nowdate.setMonth(nowdate.getMonth()-1);
      let y = nowdate.getFullYear();
      let m = nowdate.getMonth()+1;
      let d = nowdate.getDate();
      return   y+'-'+m+'-'+d;
    }
    const columns = [

        {
            title: "分组名称",
            key: "group_name",
            width:"150px",
            ellipsis: true,
            dataIndex: "group_name",
        },
        {
            title: "按钮名称",
            key: "btn_name",
            ellipsis: true,
            dataIndex: "btn_name",

        },
        {
            title: "触发总次数",
            key: "total_times",
            ellipsis: true,
            dataIndex: "total_times",
            sorter: true,
        },
        {
            title: "触发总人数",
            key: "total_users",
            ellipsis: true,
            dataIndex: "total_users",
            sorter: true,
          scopedSlots: {customRender: "total_users"}
        },
        {
            title: "人均触发次数",
            key: "avg_times",
            ellipsis: true,
            dataIndex: "avg_times",
            sorter: true,
        }
    ];
    export default {
        name: 'index',
        data() {

            return {
              disabledDate(current) {

                // return current && current <moment().subtract(1,"days");//当天之前的不可选，不包括当天

               return current && current > moment().endOf('day');

              },
                loading: true,
                data: [],
                selectedRowKeys: [], // Check here to configure the default column
                columns,
                statistics_date:[],
                search: {
                    group_id: "",
                    btn_id:"",
                    statistics_date:"",
                },
                seachList:{
                  groupList:[],
                  btnList:[]
                },
              pagination: {
                pageNo: 1,
                pageSize: 20, // 默认每页显示数量
                onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                onChange: this.getList.bind(this), //点击页码事件
                total: 0, //总条数
                current: 0,
                size: "small",
                showTotal: total => `共 ${total} 条`,
                showQuickJumper: true
              },
                // pagination: {
                //     pageNo: 1,
                //     pageSize: 20, // 默认每页显示数量
                //     onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                //     onChange: this.getList.bind(this), //点击页码事件
                //     total: 0, //总条数
                //     current: 0,
                //     size: "small",
                //     showTotal: total => `共 ${total} 条`,
                //     showQuickJumper: true
                // },
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/DataStatistics/Behavior"; //设置左侧导航2-2 active
        },
        computed: {
            hasSelected() {
                return this.selectedRowKeys.length > 0;
            },
          statisticsDate(){
              let dataArr=[]
            if (this.statistics_date.length > 0) {
              dataArr[0] = moment(this.statistics_date[0]).format('YYYY-MM-DD')
              dataArr[1] = moment(this.statistics_date[1]).format('YYYY-MM-DD')
            }
            return dataArr
          },

        },

        methods: {
          moment,
          empty(){
                this.search.group_id=""
                this.search.btn_id=""
                this.search.statistics_date=""
                this.statistics_date=""
                this.seachList = {
                      groupList:[],
                      btnList:[]
                }
                this.getList()
            this.getBtnGroup()
            },
            handleChange(pagination, filters, sorter) {

              if(sorter.columnKey){
                if(sorter.order) {
                    let sort=sorter.order=="ascend"?"ASC":"DESC"
                    this.search.order_field=sorter.columnKey
                    this.search.order_sort=sort
                }else{
                    delete this.search.order_field
                    delete this.search.order_sort
                }
                let seachData = JSON.parse(JSON.stringify(this.search))
                API.service.GET_LIST({page: this.page || 1, ...seachData}).then(res => {
                    this.selectedRowKeys=[]
                    this.data = res.data.data.data
                    this.pagination.total=res.data.data.total
                    this.pagination.pageSize=res.data.data.per_page
                    this.pagination.current=res.data.data.current_page
                    this.loading = false
                })
            }  },
            exportList(){
                let seachData = JSON.parse(JSON.stringify(this.search))
                API.service.EXPORT({...seachData ,ids:this.selectedRowKeys }).then(res => {
                    window.open( `${this.$store.state.urlExper}${res.data.data.path.substr(1)}`  )
                })
            },
            getList(page) {
                let seachData = JSON.parse(JSON.stringify(this.search))
                API.service.GET_LIST({page: page || 1, ...seachData}).then(res => {
                    this.data = res.data.data.data
                    this.pagination.total=res.data.data.total
                    this.pagination.pageSize=res.data.data.per_page
                    this.pagination.current=res.data.data.current_page
                    this.selectedRowKeys=[]
                    this.loading = false
                })
            },
            getBtnGroup(){
                API.service.GET_BTN().then(res=>{
                    this.seachList.groupList = res.data.data.group
                })
            },
            getBtnList(value){
                let group_id = value;
                this.seachList.btnList=[]
                this.search.btn_id = undefined
                API.service.GET_BTN({'group_id':group_id}).then(res=>{
                    this.seachList.btnList = res.data.data.btn
                })
            },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            },
            onChangeTime(date, dateString ,type) {
                this.type = date
                dateString[0] = moment(dateString[0]).format('YYYY-MM-DD')
                dateString[1] = moment(dateString[1]).format('YYYY-MM-DD')
                let dateStrings=`${dateString[0]}~${dateString[1]}`
                if(dateString[0] == 'Invalid date'){
                    dateStrings = ""
                }
                this.search[type] = dateStrings
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
        },
        mounted() {
          this.statistics_date=[nowdate(),fdate()]
          this.search["statistics_date"] = `${nowdate()}~${fdate()}`
          this.getList()
            this.getBtnGroup()

        }

    }
</script>
<style scoped>
    .inputs {
        display: inline-block;
        width: 70px
    }
    .search-group {
        float: right;
    }
    .search-group .ant-input {
        width: 200px;
        margin: 0 8px 0 0 ;
    }
    .button-group {
        float: left;
    }
    #list_order {
        width: 50px;
    }
    .top .flex{ box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);padding:10px 16px;box-sizing: border-box;width: 60%;margin-bottom: 20px}
    .seachBox{display: flex;}
    .seachBox .seachList{flex-wrap: nowrap;display: flex;width:20%; margin: 5px 0;}
    /*.seachs-time{min-width: 220px;}*/
    .seachBox .seachList .name{white-space:nowrap;}
</style>
